import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ThemingService} from './services/theming.service';

@NgModule({
  imports: [
    CoreModule
  ],
  providers: [ThemingService],
  declarations: []
})
export class ThemingModule { }

